import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-configurator-list',
  templateUrl: './configurator-list.component.html',
  styleUrls: ['../profile/profile.component.scss']
})
export class ConfiguratorListComponent implements OnInit {
  currentPageConfigurator: any = 1;
  itemsperpageconfigurator: any = 9;
  totalItemsConfigurator: any = 0
  breadcrumbData: any = [];
  activityDeatils: any;
  sub: Subscription = new Subscription
  apicalled:boolean=false
  confJson: any;
  environment1 = environment.s3bucket.url;

  constructor( public skeletonService: SkeletonService,
    private commonService:CommonService,private apiService: ApiService,private router: Router,) { }

  ngOnInit(): void {
    this.currentPageConfigurator = 1
      let req = {
        "from_date": "",
        "to_date": "",
        "type": "all",
        "offset": 0,
        "row": 9
      };
      this.getconfiguratorDetails(req);
      this.breadcrumbData = ['account', 'configuration']
      this.commonService.showBreadCrumbb('configuration');
  }

  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();
  mobileBack() {
    this.goBack.emit();
  }
  pageChangeConfigurator(page: any) {
    this.currentPageConfigurator = page;
    page = page - 1;
    let reqBody =
    {
      "from_date": "",
      "to_date": "",
      "type": "all",
      "offset":page * 9,
      "row": 9
    };
    this.getconfiguratorDetails(reqBody);
  }
  getconfiguratorDetails(data) {
    this.totalItemsConfigurator = 0
    this.apicalled=true
    this.sub.add(this.apiService.getActivityDetailsData(data).subscribe({
      next: (res: any) => {
        if(res.STATUS == 'SUCCESS'){
          this.activityDeatils = res.RESPONSE?.DATA;
          // this.activityDeatils=[]
 this.apicalled=false
          this.totalItemsConfigurator = res?.RESPONSE.TOTAL_COUNT
          window.scroll(0, 0);

        }
      }
    }))
  }

  getdataofconfiguratorjson(item) {
    this.confJson = item.last_visited_step_json.replace(" \ ", "")
    let aaa: any = JSON.parse(this.confJson)
    if(aaa?.stepState==undefined){
      aaa?.stepArr.forEach(e => {
        if (e?.active == true) {
          this.router.navigate(["osp-configurator" + '/' + item.configuration_id]);
        }
      })
    }
    else{
      aaa?.stepState?.stepArr.forEach(e => {
        if (e?.active == true) {
          this.router.navigate(["osp-configurator" + '/' + item.configuration_id]);
        }
      })
    }
  }

}
